import React  from 'react';
import styled from 'styled-components';

export default function MypageTopGuest(props) {
    return (
        <TopInner style={{borderBottom:props.borderbottom}}>
            <Title>{props.title}</Title>
        </TopInner>
    );
}

const TopInner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 200;
    width: 100%;
    height: calc(100vw*(51/375));
    display: felx;
    align-items: center;
    padding:0 calc(100vw*(17/375));
`
const Title = styled.h1`
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
`